import ExcelJS from "exceljs";

export class ExcelServicesBase {
    getStyle() {
        const style = {
            height: 16,
            normalFont: { name: "Tahoma", family: 4, size: 10, bold: false },
            titleFont: { name: "Tahoma", family: 4, size: 10, bold: true },
            fill: { type: "pattern", pattern: "solid", fgColor: { argb: "eeeeee" } },
        };
        return style;
    }

    createWorkbook(): ExcelJS.Workbook {
        const date = new Date();
        const workbook: any = new ExcelJS.Workbook();
        workbook.creator = "bobbee";
        workbook.created = date;
        workbook.calcProperties.fullCalcOnLoad = true;
        workbook.language = "fr-FR";
        return workbook;
    }

    applyProperties(row, font, fill, height) {
        if (row) {
            row.font = font;
            if (fill) row.fill = fill;
            if (height) row.height = 14;
            row.eachCell((cell, colNumber) => {
                // console.log('Cell ' + colNumber + ' = ' + cell.value);
                if (colNumber === 1) {
                    cell.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
                } else {
                    cell.alignment = { vertical: "middle", horizontal: "right" };
                }
            });
        } else {
            debugger;
        }
    }

    static createWorksheet(
        workbook,
        worksheetTitle: string,
        table,
        periods,
        tags,
        exportEdition: string
    ) {
        // unique worksheet name
        let title = worksheetTitle;
        let suffix: number = 2;
        while (workbook.getWorksheet(title)) {
            title = title.length === 31 ? title.slice(0, -1) + suffix : title + suffix;
            suffix++;
        }

        // worksheet creation
        const worksheet = workbook.addWorksheet(title);

        const isMonthly: boolean = !!table.rows.find((row) => row.monthlyAmounts);

        // headers
        if (isMonthly) {
            // monthly
            const headerRowData: string[] = [
                "Postes",
                "Jan",
                "Fev",
                "Mar",
                "Avr",
                "Mai",
                "Jun",
                "Jui",
                "Aou",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
                "Total N",
                "N-1",
            ];
            worksheet.addRow(headerRowData).eachCell({ includeEmpty: true }, (cell) => {
                cell.font = { name: "Tahoma", size: 10, bold: true };
            });
        } else if (tags) {
            // operating account from partition
            // first row
            const headerFirstLine = table.headers[0];
            let headerFirstRowData: string[] = ["", headerFirstLine[1].text];
            if (periods?.length > 1) {
                table.columns.forEach((col) => headerFirstRowData.push(""));
                headerFirstRowData[headerFirstRowData.length - 1] = headerFirstLine[2].text;
            }
            worksheet.addRow(headerFirstRowData).eachCell({ includeEmpty: true }, (cell) => {
                cell.font = { name: "Tahoma", size: 10, bold: true };
            });
            // second row
            const headerSecondLine = table.headers[1];
            const headerSecondRowData: string[] = headerSecondLine.map((column) => column.text);
            worksheet.addRow(headerSecondRowData).eachCell({ includeEmpty: true }, (cell) => {
                cell.font = { name: "Tahoma", size: 10, bold: true };
            });
        } else if (table.name === "Actif") {
            // balance sheet first part
            const periodN = table.headers[0][1].text;
            const periodN1 = table.headers[0][2].text;
            const headerBalanceSheetRowData: string[] = [
                table.headers[1][0].text,
                `${table.headers[1][1].text} ${periodN}`,
                `${table.headers[1][2].text} ${periodN}`,
                `${table.headers[1][3].text} ${periodN}`,
                "%",
                periodN1,
                "%",
            ];
            worksheet.addRow(headerBalanceSheetRowData).eachCell({ includeEmpty: true }, (cell) => {
                cell.font = { name: "Tahoma", size: 10, bold: true };
            });
        } else {
            // others
            const headerFirstLine = table.headers[0];
            const headerSecondLine = table.headers[1];
            let headerUniqueRowData: string[] = [];
            for (let i = 0; i < headerFirstLine.length; i++) {
                headerUniqueRowData.push(headerFirstLine[i].text || headerSecondLine[i].text);
            }
            worksheet.addRow(headerUniqueRowData).eachCell({ includeEmpty: true }, (cell) => {
                cell.font = { name: "Tahoma", size: 10, bold: true };
            });
        }

        // body
        let totalN: number = 0;
        let totalN1: number = 0;
        if (table.name === "Actif") {
            totalN = table.rows[table.rows.length - 1].netAmounts[0];
            totalN1 = table.rows[table.rows.length - 1].netAmounts[1];
        }
        const tagNames: string[] = tags?.map((tag) => tag.name) || [];
        tagNames.push(
            "untaggedColumn",
            "#SUM#",
            "grossAmounts",
            "amortizationProvisions",
            "netAmounts",
            "subRows",
            "monthlyAmounts"
        );
        table.rows.forEach((row) => {
            // preparation
            let rowData = [];
            const rowTitle: string = row.title;
            const isCategoryTitle: boolean = [
                "Produits d'exploitation",
                "Charges d'exploitation",
                "Dotations d'exploitations",
                "Produits Financiers",
                "Charges Financières",
                "Produits exceptionnels",
                "Charges exceptionnelles",
            ].includes(rowTitle);
            rowData.push(rowTitle || (row.aaName ? row.aaName + " - " + row.name : row.name));
            const sign: number = row.displaySign || 1;
            const difference = row.difference ? row.difference * sign : 0;
            const percentage = row.percentage || 0;
            Object.keys(row).forEach((prop) => {
                if (!tagNames.includes(prop)) {
                    delete row[prop];
                }
            });

            // row creation
            if (table.name === "Actif") {
                // balance sheet first part
                if (row.grossAmounts) {
                    const value1 = row.grossAmounts[0];
                    const value2 = row.amortizationProvisions[0];
                    const value3 = row.netAmounts[0];
                    const value4 = (value3 / totalN) * 100;
                    const value5 = row.netAmounts[1];
                    const value6 = (value5 / totalN1) * 100;
                    const values = [value1, value2, value3, value4, value5, value6];
                    rowData.push(...values.map((val) => parseFloat(val.toFixed(2))));
                }
            } else {
                // others
                if (isMonthly) {
                    for (let monthValue of row.monthlyAmounts.netAmounts) {
                        monthValue = monthValue * sign;
                        rowData.push(parseFloat(monthValue.toFixed(2)));
                    }
                    delete row.monthlyAmounts; // to avoid duplicate monthly amounts during the period for loop
                }
                for (let period = 0; period < periods.length; period++) {
                    for (const tag in row) {
                        if (tag === "subRows") {
                            // ignore subRows, processed later
                            continue;
                        }
                        const periodValue =
                            typeof row[tag]?.[period] === "number"
                                ? rowData[0].startsWith("%")
                                    ? row[tag][period] * 100 * sign
                                    : row[tag][period] * sign
                                : 0;
                        rowData.push(parseFloat(periodValue?.toFixed(2)));
                    }
                }
                if (!isCategoryTitle && !isMonthly) {
                    if (table.comparison?.difference) {
                        rowData.push(parseFloat(difference.toFixed(2)));
                    }
                    if (table.comparison?.percentage) {
                        rowData.push(parseFloat(percentage.toFixed(2)));
                    }
                }
            }
            const addedRow = worksheet.addRow(rowData);

            // row formatting
            if (rowTitle) {
                addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                    cell.font = { name: "Tahoma", size: 10 };
                    cell.fill = !isCategoryTitle && {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "D3D3D3" },
                    };
                    if (colNumber === 1) {
                        cell.font = { ...cell.font, bold: true };
                    }
                });
            } else {
                addedRow.eachCell({ includeEmpty: true }, (cell) => {
                    cell.font = { name: "Tahoma", size: 10 };
                });
            }

            // additions for detailed version
            if (exportEdition === "détaillé" && row.subRows?.length) {
                for (const subRow of row.subRows) {
                    // subRow data
                    let subRowData = [];
                    subRowData.push(`${subRow.name} - ${subRow.description}`);
                    for (let period = 0; period < periods.length; period++) {
                        for (const tag in subRow.values) {
                            const periodValue = subRow.values[tag]?.[period] * sign;
                            subRowData.push(parseFloat(periodValue?.toFixed(2)));
                        }
                    }
                    const addedSubRow = worksheet.addRow(subRowData);

                    // subRow formatting
                    addedSubRow.eachCell({ includeEmpty: true }, (cell) => {
                        cell.font = { name: "Tahoma", size: 9 };
                    });
                }
            }
        });

        // global formatting
        worksheet.columns = worksheet.columns.map((col, index) => ({
            width:
                // balance sheet
                ["Actif", "Passif"].includes(table.name)
                    ? // first line
                      index === 0
                        ? 52
                        : // second, third, fourth and fifth lines
                        [1, 2, 3, 5].includes(index)
                        ? 22
                        : // other lines
                          12
                    : // other sheets
                    // first line
                    index === 0
                    ? // general ledger sheet
                      table.name === "Comptes comptables"
                        ? 60
                        : // other sheets
                          52
                    : // other lines
                    // monthly sheet
                    isMonthly
                    ? 12
                    : // other sheets
                      18,
        }));
        worksheet.eachRow({ includeEmpty: true }, (row) => {
            row.height = 18;
            row.eachCell({ includeEmpty: true }, (cell) => {
                if (typeof cell.value === "number") {
                    cell.numFmt = "#,##0.00";
                }
            });
        });

        // note because it bothered me: 5 columns minimum on Excel and 10 rows (seen on Mac)
    }
}
